
import {isProxy, toRaw} from 'vue'
import Links from '@library/components/Atoms/Link/Links.vue'
export default {
  name: 'SideNavContactUs',
  components: {Links},
  data: () => ({
    activeSubMenu: false
  }),
  props: {
    labels: Object,
    activeMenu: {
      type: Boolean,
      default: true
    },
    telephones: {
      type: Array,
      default: () => []
    },
    globalTelephone: {
      type: String,
      default: ''
    },
    defaultCountry: {
      type: String,
      default: ''
    },
    publicPath: {
      type: String,
      default: '/'
    },
    telephoneContact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filterTelephone() {
      if (this.defaultCountry === '' || !this.telephones) return null
      const listTelephones = toRaw(this.telephones)
      const filter = listTelephones.filter(item => item.country === this.defaultCountry)[0] || null
      return filter
    },
    contactTelephone() {
      return this.telephones
    }
  },
  mounted() {
    const _this = this
    const allAnchorsTlf = Array.from(document.querySelectorAll('a')).filter(anchor => anchor.href.startsWith('tel'))
    if (allAnchorsTlf) {
      allAnchorsTlf.forEach(function (tlf) {
        tlf.addEventListener('click', async event => {
          _this.$emit('trackCallUsToBook')
        })
      })
    }
  },
  methods: {
    filterObject(key) {
      const texts = {}
      return texts[key]()
    }
  }
}
